<div class="skeleton">
  <!-- sub text and bulletpoints -->
  <!-- <ng-container *ngFor="let item of skeletonItems">
    <nes-skeleton [class]="item.class" [shape]="item.shape"></nes-skeleton>
  </ng-container> -->
  
  <!-- products and links -->
  <div
    *ngFor="let index of numberOfProducts(6)"
    class="nes-flex nes-flex-col nes-mb-5"
  >
    <nes-selectable-radio nes-id="" label="" class="nes-mb-2">
      <div class="" slot="header">
        <div class="nes-flex flex nes-mb-1">
          <nes-skeleton
            class="nes-w-full nes-mr-12 nes-h-6"
            shape="heading"
            loading-text="loading products"
          ></nes-skeleton>
          <nes-skeleton class="nes-w-8 nes-h-6" shape="heading"></nes-skeleton>
        </div>
        <nes-skeleton class="nes-w-3/12 nes-h-4" shape="heading"></nes-skeleton>
      </div>
      <nes-skeleton
        slot="content"
        class="nes-w-full nes-h-20"
        shape="text"
        loading-text="loading products"
        text-lines="5"
      ></nes-skeleton>
    </nes-selectable-radio>
    <nes-skeleton
      class="nes-w-6/12 nes-mb-3 nes-h-4"
      shape="heading"
      loading-text="loading link"
      text-lines="1"
    ></nes-skeleton>
  </div>
</div>